export default function getWorkbenchByline(xmlString) {
  const matchArray = /<Byline>.*?<FirstName>(.+?)<\/FirstName>.*?<LastName>(.+?)<\/LastName>/.exec(xmlString);

  const firstName = (matchArray && matchArray[1]) || '';
  const lasttName = (matchArray && matchArray[2]) || '';

  return `${firstName} ${lasttName}`;
}
